/**
 * @generated SignedSource<<4dc1eef2d33aab44372109ccf3ed2ec3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type linkPillGetLinkInfoQuery$variables = {
  url: string;
};
export type linkPillGetLinkInfoQuery$data = {
  readonly getLinkInfo: {
    readonly icon: string | null;
    readonly title: string;
  } | null;
};
export type linkPillGetLinkInfoQuery = {
  response: linkPillGetLinkInfoQuery$data;
  variables: linkPillGetLinkInfoQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "url"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "url",
        "variableName": "url"
      }
    ],
    "concreteType": "CheckLinkNode",
    "kind": "LinkedField",
    "name": "getLinkInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "icon",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "linkPillGetLinkInfoQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "linkPillGetLinkInfoQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ed20abfc5b645e2653ea02f633fc0aff",
    "id": null,
    "metadata": {},
    "name": "linkPillGetLinkInfoQuery",
    "operationKind": "query",
    "text": "query linkPillGetLinkInfoQuery(\n  $url: String!\n) {\n  getLinkInfo(url: $url) {\n    icon\n    title\n  }\n}\n"
  }
};
})();

(node as any).hash = "e32c8de7097e6a4c3823f56e4e99a25c";

export default node;
